import axios from "axios";

export const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://app.incubationmasters.com" // Production IP and port
    : "http://localhost:5000"; // Local development server

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const userString = localStorage.getItem("user");
    if (userString) {
      try {
        const userObj = JSON.parse(userString);
        if (userObj && userObj.token) {
          config.headers.Authorization = `Bearer ${userObj.token}`;
        }
      } catch (e) {
        console.error("Error parsing user from localStorage:", e);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default API_URL;
